<template>
    <!--    第三方机构推荐-列表组件-->
  <div class="swiper-container thirdparty-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide thirdpartyslide"
         v-for="(item,index) in thirdpartydata" :key="index" :data-id="item.id">
        <div class="item-wrap">
          <div class="thirdPartyImg"> <img :src="item.logo" alt=""> </div>
          <div class="thirdPartyText">
              <p class="ptitle1">{{item.institutionName}}</p>
              <div class="spanTag">
                  <span class="spanBlue" v-if="item.serverTypeName">{{item.serverTypeName}}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- <ul class="thirdPartyList"> -->
        <!-- <li v-for="(item,index) in thirdpartydata" :key="index" @click="itemClick(item)" -->
        <!-- > -->
            <!-- <div class="thirdPartyImg"> -->
                <!-- <el-image :src="item.logo" fit="cover"></el-image> -->
            <!-- </div> -->
            <!-- <div class="thirdPartyText"> -->
                <!-- <p class="bigTitle pTitle">{{item.institutionName}}</p> -->
                <!-- <p class="smallTitle intro">{{item.brief}}</p> -->
                <!-- <div class="spanTag"> -->
                    <!-- <span class="spanBlue" v-if="item.serverTypeName">{{item.serverTypeName}}</span> -->
                <!-- </div> -->
            <!-- </div> -->
        <!-- </li> -->
<!--        id: 57-->
<!--        picture: "https://uploadfile.huicye.com/test/img/company/temp/20200617/2020/6/131577ac620445d9bb9893169952a44c.png"-->
<!--        sort: 9-->
<!--        synopsis: "哈哈哈"-->
<!--        tag: "布艺家纺专业检测平台"-->
<!--        title: "旺仔机构"-->
    <!-- </ul> -->
</template>

<script>
    import Swiper from 'swiper';
    
    export default {
        name: "lp-ThirdPartyList",
        props:['thirdpartydata'],
        data(){
            return{
                noImg:require('../../assets/images/test.jpg')
            }
        },
        watch: {
          thirdpartydata: function() {
            this.$nextTick(()=>{
              const num = this.thirdpartydata.length> 5 ? 5 : this.thirdpartydata.length;
              this.mySwiper = new Swiper('.thirdparty-container',{
                slidesPerView: num,
                loopedSlides: num,
                slidesPerGroup: num,
                autoplay: 5000, //可选选项，自动滑动
                loop: true,     //可选选项，开启循环
                speed: 300,
              }) 
            });
            setTimeout(() => {
              $('.thirdpartyslide').on('click',(e)=>{
                const id = e.currentTarget.dataset.id;
                this.$router.push({ path:"/serviceOrganization/"+ id })
              })
            }, 100);
          },
        },
    }
</script>


<style lang="less" scoped>
    .thirdparty-container {
      height: 92px;
      margin-top: 20px;
      background: transparent;
      padding-bottom: 10px;
      .swiper-wrapper {
        .swiper-slide {
          height: 92px;
          .item-wrap {
            display: flex;
            background: @backGrayColor;
            width: 224px;
            padding: 20px 20px 20px 12px;
            box-sizing: border-box;
            &:hover {
              cursor: pointer;
              background-color: #eee;
            }
          }
          .thirdPartyImg{
              width: 40px;
              img{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover; 
              }
            }
            .thirdPartyText{
                width:138px;
                overflow: hidden;
                padding-left: 12px;
                line-height: 18px;
                .ptitle1{
                    width: 100%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    margin-bottom: 12px;
                }
                .spanTag{
                    margin-bottom: 10px;
                }
            }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/thirdpartylist/index.vue